import Route from 'cio/routes/base';

export default class LegacyRedirectsRoute extends Route {
  beforeModel(transition) {
    let environment = this.modelFor('environment');
    let environmentId = environment.id;
    let redirectParams = this.paramsFor('legacy-redirects');

    if (redirectParams.v2path) {
      return this.router.transitionTo(`/env/${environmentId}/${redirectParams.v2path}`);
    }

    if (transition.intent.url.includes('triggered/new')) {
      return this.router.transitionTo(`/env/${environmentId}/campaigns/new`);
    }

    if (transition.intent.url.includes('triggered')) {
      return this.router.transitionTo(`/env/${environmentId}/campaigns`);
    }
  }
}
